export default __webpack_public_path__ + "static/media/logo-jobs.7bd7aa43.svg";